import { Classroom } from '@teetsh/app/src/types/classroom';
import { getNormalizedDay } from './getNormalizedDay';

export function getClassroomsGrouppedByDays(
  days,
  classrooms,
): { [key: number]: Classroom[] } {
  if (!days) {
    return {};
  }
  const result: { [key: number]: Classroom[] } = {};

  for (const day of days) {
    result[day] = [];
  }

  for (const classroom of classrooms) {
    for (const workingDay of classroom.workingDays) {
      const normalizedWorkingDay = getNormalizedDay(workingDay);
      if (result.hasOwnProperty(normalizedWorkingDay)) {
        result[normalizedWorkingDay].push(classroom);
      }
    }
  }

  return result;
}
